//   function initAnnouncementSlider() {
//     var $slider = $('.announcement-slider');

//     if ($slider.length && !$slider.hasClass('slick-initialized')) {
//       $slider.slick({
//         autoplay: true,
//         autoplaySpeed: 4500,   // slow autoplay
//         speed: 1500,           // smooth animation speed
//         cssEase: 'ease-in-out',
//         arrows: true,
//         dots: false,
//         infinite: true,
//         fade: false,
//         pauseOnHover: false,
//         pauseOnFocus: false,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         adaptiveHeight: false
//       });
//     }
//   }

//   document.addEventListener('DOMContentLoaded', initAnnouncementSlider);

//   // Shopify Theme Editor Fix
//   document.addEventListener('shopify:section:load', function () {
//     initAnnouncementSlider();
//   });



(function () {

  function initAnnouncementBars() {
    document.querySelectorAll('[data-announcement-bar]').forEach(bar => {

      const slides = bar.querySelectorAll('.announcement-item');
      const prev = bar.querySelector('.ann-arrow.prev');
      const next = bar.querySelector('.ann-arrow.next');

      if (!slides.length) return;

      let index = 0;
      let timer;

      // 🔥 IMPORTANT: always show first slide
      slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === 0);
      });

      function showSlide(i) {
        slides.forEach(s => s.classList.remove('active'));
        slides[i].classList.add('active');
        index = i;
      }

      function nextSlide() {
        showSlide((index + 1) % slides.length);
      }

      function prevSlide() {
        showSlide((index - 1 + slides.length) % slides.length);
      }

      function startAuto() {
        stopAuto();
        timer = setInterval(nextSlide, 4500);
      }

      function stopAuto() {
        if (timer) clearInterval(timer);
      }

      if (next) {
        next.onclick = () => {
          stopAuto();
          nextSlide();
          startAuto();
        };
      }

      if (prev) {
        prev.onclick = () => {
          stopAuto();
          prevSlide();
          startAuto();
        };
      }

      startAuto();
    });
  }

  document.addEventListener('DOMContentLoaded', initAnnouncementBars);

  // 🔥 Shopify editor fix
  document.addEventListener('shopify:section:load', initAnnouncementBars);

})();












document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector('#CartDrawer-ProductRecommendations');

  if (!container) return;

  const productId = container.dataset.productId;
  const limit = container.dataset.limit;

  fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`)
    .then(res => res.json())
    .then(data => {

      if (!data.products.length) return;

      let html = '<div class="recommendation-grid">';

      data.products.forEach(product => {
        html += `
          <div class="recommendation-item">
            <a href="${product.url}">
              <img src="${product.featured_image}" alt="${product.title}">
              <p>${product.title}</p>
              <span>Rs.${(product.price/100).toFixed(0)}</span>
            </a>
          </div>
        `;
      });

      html += '</div>';

      container.innerHTML = html;
    });
});


    document.addEventListener('DOMContentLoaded', function() {
      /* === SLIDER COUNTER === */
      var sliders = document.querySelectorAll('slider-component');
      for (var i = 0; i < sliders.length; i++) {
        (function(component) {
          var track = component.querySelector('.slider');
          var slides = component.querySelectorAll('.slider__slide');
          var currentEl = component.querySelector('.slider-counter--current');
          var totalEl = component.querySelector('.slider-counter--total');
          var prevBtn = component.querySelector('.slider-button--prev');
          var nextBtn = component.querySelector('.slider-button--next');

          if (!track || !slides.length || !currentEl || !totalEl) return;

          var total = slides.length;
          totalEl.textContent = total;
          var slideWidth = slides[0].offsetWidth;
          var scrollTimer;

          function updateCounter() {
            var index = Math.round(track.scrollLeft / slideWidth) + 1;
            if (index < 1) index = 1;
            if (index > total) index = total;
            currentEl.textContent = index;
            totalEl.textContent = total;
          }

          track.addEventListener('scroll', function() {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(updateCounter, 50);
          }, { passive: true });

          if (nextBtn) {
            nextBtn.addEventListener('click', function() {
              track.scrollBy({ left: slideWidth, behavior: 'smooth' });
              setTimeout(updateCounter, 300);
            });
          }
          if (prevBtn) {
            prevBtn.addEventListener('click', function() {
              track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
              setTimeout(updateCounter, 300);
            });
          }

          updateCounter();
        })(sliders[i]);
      }

      /* === ACCORDION === */
      var accordionBtns = document.querySelectorAll('.accordion button');
      for (var j = 0; j < accordionBtns.length; j++) {
        accordionBtns[j].addEventListener('click', function() {
          var expanded = this.getAttribute('aria-expanded') === 'true';
          for (var k = 0; k < accordionBtns.length; k++) {
            accordionBtns[k].setAttribute('aria-expanded', 'false');
          }
          if (!expanded) this.setAttribute('aria-expanded', 'true');
        });
      }

      /* === SHOW MORE HIGHLIGHT (vanilla JS, no jQuery) === */
      var menuLinks = document.querySelectorAll('li a');
      for (var m = 0; m < menuLinks.length; m++) {
        if (menuLinks[m].textContent.indexOf('Show More') !== -1) {
          menuLinks[m].classList.add('highlight-menu-item');
        }
      }
    });